import ChallengeSectionProgress from './ChallengeSectionProgress';
import ChallengeShowPrizeClothesButton from './ChallengeShowPrizeClothesButton';

export default function ChallengeAvailableInfo({ challengeData }) {
  return (
    <>
      <ChallengeSectionProgress challengeData={challengeData} />
      <ChallengeShowPrizeClothesButton challengeData={challengeData} />
    </>
  );
}
